/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Nav_ProfileInputs */

const en_settings_nav_profile = /** @type {(inputs: Settings_Nav_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const zh_settings_nav_profile = /** @type {(inputs: Settings_Nav_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个人资料`)
};

/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Settings_Nav_ProfileInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_nav_profile = /** @type {((inputs?: Settings_Nav_ProfileInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Nav_ProfileInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_nav_profile(inputs)
	return zh_settings_nav_profile(inputs)
});
export { settings_nav_profile as "settings.nav.profile" }